export enum Systems {
  SGP = 'sgp',
  IXC = 'ixc',
  BEESWEB = 'beesweb',
  MKAUTH = 'mkauth',
  MIKWEB = 'mikweb',
  RECEITA_NET = 'receitanet',
  ISPFY = 'ispfy',
  CONTROLLR = 'controllr',
  DUOBOX = 'duobox',
  HUBSOFT = 'hubsoft',
}

export const SYSTEMS_NAMES: Record<Systems, string> = {
  [Systems.SGP]: 'SGP',
  [Systems.IXC]: 'IXC',
  [Systems.BEESWEB]: 'BeesWeb',
  [Systems.MKAUTH]: 'MK Auth',
  [Systems.MIKWEB]: 'MikWeb',
  [Systems.RECEITA_NET]: 'Receita Net',
  [Systems.ISPFY]: 'ISPFY',
  [Systems.CONTROLLR]: 'Controllr',
  [Systems.DUOBOX]: 'Duobox',
  [Systems.HUBSOFT]: 'Hubsoft',
}
